module.exports = __webpack_public_path__ + "media/img/pages/companies/ost-f523e12e0140d98f5f7d7ba22ed0d0a7.webp";